import { Content, FormatContent } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { Button } from 'src/core/ui';
import { SwitchIcon } from 'src/svgs/SwitchIcon';
import { ContentId } from 'src/utils/constants/contentId';
import { FormatContentId } from 'src/utils/constants/formatContentId';

import { SponsoredListingsSectionType } from '../SponsoredListings.types';

export const SwitchToButton = ({
  sectionType,
  onSwitchSection,
}: {
  sectionType: SponsoredListingsSectionType;
  onSwitchSection: (sectionType: SponsoredListingsSectionType) => void;
}) => {
  const switchContentId = (sectionType: SponsoredListingsSectionType) => {
    switch (sectionType) {
      case SponsoredListingsSectionType.CampaignsView:
        return ContentId.Timeline;
      case SponsoredListingsSectionType.TimelineView:
        return ContentId.Campaigns;
      default:
        return '';
    }
  };

  const getNextSectionType = (sectionType: SponsoredListingsSectionType) => {
    switch (sectionType) {
      case SponsoredListingsSectionType.CampaignsView:
        return SponsoredListingsSectionType.TimelineView;
      case SponsoredListingsSectionType.TimelineView:
        return SponsoredListingsSectionType.CampaignsView;
      default:
        return SponsoredListingsSectionType.CampaignsView;
    }
  };

  return (
    <Button
      variant="textPlain"
      onClick={() => onSwitchSection(getNextSectionType(sectionType))}
    >
      <SwitchIcon size={vars.iconSize.m} stroke={vars.color.textBrand} />
      <div style={{ width: 'max-content' }}>
        <FormatContent
          id={FormatContentId.SwitchTo}
          params={<Content id={switchContentId(sectionType)} />}
        />
      </div>
    </Button>
  );
};
